import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=77165e1d&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77165e1d')) {
      api.createRecord('77165e1d', component.options)
    } else {
      api.reload('77165e1d', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=77165e1d&", function () {
      api.rerender('77165e1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26K0aBrqqIhnN/JS/comp/ErrorMessage.vue"
export default component.exports